import { init, thumbnailDecorator } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"
import {unbindOriginalSearch, updateSearchAria} from "./helpers"

import "./styles/index.css"


const selectorsToRemove = [
    'side-panel[name="search-panel"] div[data-search-results]', 'side-panel[name="search-panel"] div.mb-14',
    "#nostoTargetAutocomplete ul.list-none","#nostoTargetAutocomplete p.paragraph-3.uppercase"
]

selectorsToRemove.forEach(selector => {
    // console.log(document.querySelectorAll(selector));
    document.querySelectorAll(selector).forEach(el => el.remove());
})

const inputSelector = "#SearchAutocomplete";

// Declare trap variable globally so it can be accessed by all functions
let trap = null;

// unbindOriginalSearch(inputSelector);

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: inputSelector,
    contentCssSelector: "#nostoTargetSERP",
    // contentCssSelector: "#MainContent",
    // dropdownCssSelector: "div[data-trending-searches]",
    dropdownCssSelector: "#nostoTargetAutocomplete",
    // formCssSelector: "#search-form",
    hitDecorators: [
        thumbnailDecorator({ size: "9" })
    ],
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    serpPath: '/search',

    // Uncomment to redirect to search page instead of rewriting browser history
    serpPathRedirect: true,
    serpQuery: {
        products: {
            // fields: [
            //     "productId",
            //     "url",
            //     "name",
            //     "imageUrl",
            //     "imageHash",
            //     "thumbUrl",
            //     "description",
            //     "brand",
            //     "availability",
            //     "price",
            //     "priceText",
            //     "listPrice",
            //     "ratingValue",
            //     "reviewCount"
            // ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            // fields: [
            //     "productId",
            //     "url",
            //     "name",
            //     "imageUrl",
            //     "thumbUrl",
            //     "brand",
            //     "availability",
            //     "price",
            //     "priceText",
            //     "listPrice",
            //     "ratingValue",
            //     "reviewCount"
            // ],
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    compressUrlParameters: true,
    fallback: true,
    // // Uncomment for Category Merchandising
    categoryCssSelector: '#nostoTargetPLP',
    categoryQuery() {
        return {
            name: 'serp',
            products: {
                categoryId: this.categoryId(),
                categoryPath: this.categoryPath(),
                size: defaultConfig.categorySize,
                from: 0,
            }
        }
    },
}).then(()=>{
    console.log('Nosto Search initialized');
    if (window.innerWidth > 767) {
        const searchDiv = document.querySelector('[data-open-search] > div');
    
        if (searchDiv) {
            const handleClickOrKeyPress = (event) => {
                if (event.type === 'click') {
                    // event.preventDefault();
                    setTimeout(() => {
                        const input = document.querySelector(inputSelector);
                        if (input) {
                            input.click();
                        }
                    }, 100);
                } else if(event.type === 'keydown' && event.key === ' '){
                    // event.preventDefault();
                    setTimeout(() => {
                        const input = document.querySelector(inputSelector);
                        if (input) {
                            input.click();
                        }
                    }, 200);
                }
            };
        
            // Add event listeners for both click and keydown events
            searchDiv.addEventListener('click', handleClickOrKeyPress);
            searchDiv.addEventListener('keydown', handleClickOrKeyPress);
        }
    }

    const sideSearchPanel = document.querySelector('side-panel[name="search-panel"]');
    if(sideSearchPanel){
        sideSearchPanel.setAttribute('id', 'focus-trap');
        sideSearchPanel.setAttribute('role', 'dialog');
        sideSearchPanel.setAttribute('aria-modal', 'true');
        sideSearchPanel.setAttribute('aria-label', 'Search');
        
        // Store reference to the element that opened the modal for focus return
        let triggerElement = null;
        
        // Monitor when modal opens
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                    if (sideSearchPanel.hasAttribute('open')) {
                        // Modal opened
                        triggerElement = document.activeElement;
                        setTimeout(() => {
                            const searchInput = sideSearchPanel.querySelector('#SearchAutocomplete');
                            if (searchInput) {
                                searchInput.focus();
                            }
                        }, 100);
                    } else {
                        // Modal closed - return focus
                        if (triggerElement) {
                            triggerElement.focus();
                            triggerElement = null;
                        }
                    }
                }
            });
        });
        
        observer.observe(sideSearchPanel, { 
            attributes: true, 
            attributeFilter: ['open'] 
        });
    }

    trap = document.getElementById('focus-trap');
    
    // Fix hidden focusable elements to prevent focus trapping
    const fixHiddenFocusableElements = () => {
        const hiddenFocusableElements = document.querySelectorAll('[tabindex="0"]');
        hiddenFocusableElements.forEach(el => {
            const style = window.getComputedStyle(el);
            if (style.display === 'none' || style.visibility === 'hidden') {
                el.setAttribute('tabindex', '-1'); // Make it not focusable
            }
        });
    };
    
    // Run immediately and periodically to catch dynamic changes
    fixHiddenFocusableElements();
    setInterval(fixHiddenFocusableElements, 1000);

    const focusableSelectors = [
        'input:not([disabled]):not([tabindex="-1"])',
        'button:not([disabled]):not([tabindex="-1"])',
        'select:not([disabled]):not([tabindex="-1"])',
        'textarea:not([disabled]):not([tabindex="-1"])',
        'a[href]:not([tabindex="-1"])',
        '[tabindex="0"]:not([style*="display: none"]):not([style*="visibility: hidden"])',
        '[role="option"]',
        '.ns-autocomplete-element',
        '.ns-top-category',
        'h1[tabindex="0"], h2[tabindex="0"], h3[tabindex="0"], h4[tabindex="0"], h5[tabindex="0"], h6[tabindex="0"]'
    ];

    function getFocusableElements() {
        // First, determine which component is currently visible/active
        const autocompleteContainer = document.querySelector('#nosto-autocomplete-container');
        const historyContainer = document.querySelector('#nosto-history-container');
        const searchInput = document.querySelector('#SearchAutocomplete');
        
        let activeContainer = null;
        let containerType = 'none';
        
        // Determine active container based on search input state and container visibility
        if (searchInput && searchInput.value && searchInput.value.trim().length > 0) {
            // If there's a search query, autocomplete should be active
            if (autocompleteContainer) {
                const autoStyle = window.getComputedStyle(autocompleteContainer);
                const isVisible = autoStyle.display !== 'none' && autoStyle.visibility !== 'hidden' && autocompleteContainer.offsetParent !== null;
                if (isVisible) {
                    activeContainer = autocompleteContainer;
                    containerType = 'autocomplete';
                }
            }
        } else {
            // If no search query, history should be active
            if (historyContainer) {
                const historyStyle = window.getComputedStyle(historyContainer);
                const isVisible = historyStyle.display !== 'none' && historyStyle.visibility !== 'hidden' && historyContainer.offsetParent !== null;
                if (isVisible) {
                    activeContainer = historyContainer;
                    containerType = 'history';
                }
            }
        }
        
        // Fallback: check which container is actually visible
        if (!activeContainer) {
            if (autocompleteContainer) {
                const autoStyle = window.getComputedStyle(autocompleteContainer);
                if (autoStyle.display !== 'none' && autoStyle.visibility !== 'hidden' && autocompleteContainer.offsetParent !== null) {
                    activeContainer = autocompleteContainer;
                    containerType = 'autocomplete';
                }
            }
            
            if (!activeContainer && historyContainer) {
                const historyStyle = window.getComputedStyle(historyContainer);
                if (historyStyle.display !== 'none' && historyStyle.visibility !== 'hidden' && historyContainer.offsetParent !== null) {
                    activeContainer = historyContainer;
                    containerType = 'history';
                }
            }
        }

        // Get all focusable elements in the trap
        const allElements = trap.querySelectorAll(focusableSelectors.join(','));
        
        // Filter to only include visible elements from the active container
        const visibleElements = Array.from(allElements).filter(el => {
            const style = window.getComputedStyle(el);
            const isVisible = style.display !== 'none' && style.visibility !== 'hidden' && el.offsetParent !== null;
            
            if (!isVisible) return false;
            
            // Always include the search input and close button regardless of container
            if (el.id === 'SearchAutocomplete' || 
                el.getAttribute('data-close-search') !== null ||
                el.closest('[data-close-search]')) {
                return true;
            }
            
            // If we have an active container, only include elements from that specific container
            if (activeContainer) {
                const isInActiveContainer = activeContainer.contains(el);
                const isInOtherContainer = (autocompleteContainer && autocompleteContainer !== activeContainer && autocompleteContainer.contains(el)) ||
                                        (historyContainer && historyContainer !== activeContainer && historyContainer.contains(el));
                
                // Include element if it's in active container and NOT in any other container
                return isInActiveContainer && !isInOtherContainer;
            }
            
            // If no active container determined, include all visible elements
            return true;
        });
        
        return visibleElements;
    }

    // Comprehensive focus trap - works globally to prevent focus from leaving the sidebar
    let isModalOpen = false;
    
    // Monitor modal state
    const updateModalState = () => {
        isModalOpen = sideSearchPanel && sideSearchPanel.hasAttribute('open');
        
        if (isModalOpen) {
            // Find all top-level elements outside the modal
            const topLevelElements = Array.from(document.body.children).filter(el => 
                !trap.contains(el) && el !== trap && el.tagName !== 'SCRIPT' && el.tagName !== 'STYLE'
            );
            
            topLevelElements.forEach(el => {
                // Use inert attribute if supported (modern browsers)
                if ('inert' in el) {
                    el.inert = true;
                    el.setAttribute('data-was-inert', 'true');
                } else {
                    // Fallback: make all focusable elements non-focusable
                    const focusableElements = el.querySelectorAll(
                        'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
                    );
                    focusableElements.forEach(focusEl => {
                        if (focusEl.hasAttribute('tabindex')) {
                            focusEl.setAttribute('data-original-tabindex', focusEl.getAttribute('tabindex'));
                        } else {
                            focusEl.setAttribute('data-original-tabindex', '0');
                        }
                        focusEl.setAttribute('tabindex', '-1');
                    });
                }
            });
        } else {
            // Restore original focus states
            document.querySelectorAll('[data-was-inert]').forEach(el => {
                el.inert = false;
                el.removeAttribute('data-was-inert');
            });
            
            document.querySelectorAll('[data-original-tabindex]').forEach(el => {
                const originalTabindex = el.getAttribute('data-original-tabindex');
                el.removeAttribute('data-original-tabindex');
                if (originalTabindex === '0') {
                    el.removeAttribute('tabindex');
                } else {
                    el.setAttribute('tabindex', originalTabindex);
                }
            });
        }
    };
    
    // Update modal state when the modal opens/closes
    const modalObserver = new MutationObserver(updateModalState);
    modalObserver.observe(sideSearchPanel, { 
        attributes: true, 
        attributeFilter: ['open'] 
    });
    
    // Global keydown handler for escape and comprehensive tab trapping
    document.addEventListener('keydown', function(e) {
        if (!isModalOpen) return;
        
        if (e.key === 'Escape') {
            e.preventDefault();
            // Close the search modal
            const closeButton = sideSearchPanel.querySelector('[data-close-search]') || 
                            sideSearchPanel.querySelector('button[aria-label*="Close"]') ||
                            sideSearchPanel.querySelector('.close');
            if (closeButton) {
                closeButton.click();
            } else {
                sideSearchPanel.removeAttribute('open');
            }
            return;
        }
        
        // Comprehensive tab trapping
        if (e.key === 'Tab') {
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            
            const firstEl = focusableElements[0];
            const lastEl = focusableElements[focusableElements.length - 1];
            const currentEl = document.activeElement;
            
            // If focus is outside the modal, bring it back inside
            if (!trap.contains(currentEl)) {
                e.preventDefault();
                firstEl.focus();
                return;
            }
            
            // Handle boundary cases
            if (e.shiftKey && currentEl === firstEl) {
                e.preventDefault();
                lastEl.focus();
            } else if (!e.shiftKey && currentEl === lastEl) {
                e.preventDefault();
                firstEl.focus();
            }
        }
    }, true); // Use capture phase to catch all events

    updateSearchAria('history');

    // Note: Focus trap for filters sidebar is now handled in Sidebar.jsx component
})


